import React, { Component } from "react";
import PropTypes from "prop-types";
import { Typography, Select, Input, Checkbox, Button } from "antd";
import { withRouter } from "react-router-dom";

import "./GeneralInfoTab.css";

const { Title, Text, Paragraph } = Typography;
const { Option } = Select;

const INDUSTRY_CATEGORIES = [
  { key: "AGRICULTURE", value: "Agriculture and Fishing" },
  { key: "MINING", value: "Mining and Quarrying" },
  { key: "MANUFACTURING", value: "Manufacturing" },
  {
    key: "ENERGY",
    value: "Electricity, Gas, Steam and Air-Conditioning Supply"
  },
  {
    key: "WATER",
    value:
      "Water Supply; Sewerage, Waste Management 41 and Remediation Activities  "
  },
  { key: "CONSTRUCTION", value: "Construction" },
  { key: "TRANSPORT", value: "Transportation and Storage" },
  { key: "FOOD", value: "Accommodation and Food Service Activities" },
  { key: "INFORMATION", value: "Information and Communications" },
  { key: "FINANCIALSERVICES", value: "Financial and Insurance Activities" },
  { key: "HOSPITALITY", value: "Real Estate Activities" },
  {
    key: "COMPUTERS",
    value: "Professional, Scientific and Technical Activities"
  },
  { key: "SERVICES", value: "Administrative and Support Service Activities" },
  { key: "DEFENSE", value: "Public Administration and Defence" },
  { key: "EDUCATION", value: "Education" },
  { key: "HEALTHCARE", value: "Health and Social Services" },
  { key: "ENTERTAIMENT", value: "Arts, Entertainment and Recreation" },
  { key: "OTHER", value: "Other Service Activities" },
  {
    key: "AEROSPACE",
    value: "Activities of Extra-Territorial Organisations and Bodies "
  }
];
const COUNTRIES = ["Singapore", "Australia", "Hongkong"];

class GeneralInfoTab extends Component {
  constructor(props) {
    super(props);
    const { country, industry, website } = props.corporateAccount;
    const { corporateRole, role = corporateRole } = props.customer;

    this.state = {
      country: country || COUNTRIES[0],
      industry: industry || INDUSTRY_CATEGORIES[0].key,
      role: role || "LEGAL_REPRESENTATIVE",
      website: website || "",
      checked: !!website || false // just check a field to ensure corporateAccount was created
    };
  }

  componentWillReceiveProps({ corporateAccount, customer }) {
    const { country, industry, website } = corporateAccount;
    const { corporateRole, role = corporateRole } = customer;
    this.setState({
      country,
      industry,
      website,
      role: role || "LEGAL_REPRESENTATIVE"
    });
  }

  handleSkip = e => {
    this.props.history.push("/");
  };

  handleSubmit = () => {
    const submittedObj = {
      ...this.state,
      corporateRole: this.state.role
    };
    console.log(submittedObj);
    this.props.onSubmit(submittedObj);
  };

  renderIndustry = industry => (
    <Option key={industry.key} value={industry.key}>
      {industry.value}
    </Option>
  );

  renderCountry = country => (
    <Option value={country} key={country}>
      {country}
    </Option>
  );

  render() {
    const { country, industry, website, role, checked } = this.state;
    const fulfilled = !!role && checked;
    return (
      <div className="general-info-tab">
        <div className="left-pane">
          <div className="general-info-wrapper">
            <Title level={4}>Company Details</Title>

            <Text className="form-title">Country</Text>
            <Select
              value={country}
              style={{ width: "60%", marginBottom: 14 }}
              size="large"
              onChange={country => this.setState({ country })}
            >
              {COUNTRIES.map(this.renderCountry)}
            </Select>

            <Text className="form-title">Industry Category</Text>
            <Select
              style={{ width: "60%", marginBottom: 14 }}
              size="large"
              onChange={industry => this.setState({ industry })}
              value={industry}
            >
              {INDUSTRY_CATEGORIES.map(this.renderIndustry)}
            </Select>

            <Text className="form-title">Company Website</Text>
            <Input
              style={{ width: "60%", marginBottom: 14 }}
              size="large"
              onChange={e => this.setState({ website: e.target.value })}
              value={website}
            />

            <Checkbox
              onChange={e => this.setState({ checked: e.target.checked })}
              disabled={!!this.props.corporateAccount.website}
              checked={checked}
            >
              I confirm that I will be the administrator of the business account
              and I am authorised to fill out this form on behalf of the
              business.
            </Checkbox>
          </div>
          <div className="button-wrapper">
            <Button className="bt-skip" onClick={this.handleSkip}>
              Skip verification for now
            </Button>
            <Button
              className="bt-next"
              type="primary"
              disabled={!fulfilled}
              onClick={this.handleSubmit}
            >
              Next
            </Button>
          </div>
        </div>
        <div className="right-pane">
          <Text className="guide-title">Company Details</Text>
          <Paragraph className="guide-para">
            {`We are required to collect your company name for verification purposes.
            You may enter company name or registration number.`}
          </Paragraph>
        </div>
      </div>
    );
  }
}

GeneralInfoTab.propTypes = {
  nextTab: PropTypes.func
};

export default withRouter(GeneralInfoTab);
